






























import { compact } from 'lodash-es'
import { Button } from '@alpha/ink'
import { Vue, Component, Prop } from 'vue-property-decorator'
import Audience, { AudienceCriteriaType, GeographicLocationType, criteriaGroups, formatUSHHINumberRange } from './Audience'
import { getCriteriaTypeTitle } from '@/utilities/audience-mappers'

interface CriteriaSummary {
  title: string
  description: string
}

@Component({
  components: {
    Button
  }
})
export default class AudienceSelectionContent extends Vue {
  @Prop({ default: null }) readonly audience!: Audience | null

  AudienceCriteriaType = AudienceCriteriaType

  get criteriaSummaryGroups (): CriteriaSummary[][] {
    if (!this.audience) return []

    const criteriaTypeGroups = [
      [AudienceCriteriaType.ADDITIONAL],
      ...criteriaGroups.map(criteriaGroup => criteriaGroup.criteriaTypes)
    ]

    return compact(criteriaTypeGroups.map(criteriaTypeGroup => {
      const criteriaSummaries = compact(criteriaTypeGroup.map(criteriaType => {
        const description = this.getCriteriaDescription(criteriaType)
        if (!description) return
        return {
          title: getCriteriaTypeTitle(criteriaType),
          description
        }
      }))

      if (criteriaSummaries.length > 0) return criteriaSummaries
    }))
  }

  getCriteriaDescription (criteriaType: AudienceCriteriaType): string | undefined {
    if (!this.audience) return
    const criteria = this.audience.criteria

    switch (criteriaType) {
      case AudienceCriteriaType.GEOGRAPHIC_LOCATION: {
        const geographicLocation = criteria[criteriaType]
        if (!geographicLocation) return
        switch (geographicLocation.type) {
          case GeographicLocationType.INTERNATIONAL:
            return `International, ${geographicLocation.countries.join(', ')}`
          case GeographicLocationType.USA_STATES:
            return `US, ${geographicLocation.states.join(', ')}`
          case GeographicLocationType.USA:
            return 'All US States'
        }
      }
      // eslint-disable-next-line no-fallthrough
      case AudienceCriteriaType.AGE: {
        const ageRange = criteria[criteriaType]
        if (!ageRange) return
        return `${ageRange[0]}-${ageRange[1]} years old`
      }
      case AudienceCriteriaType.US_HHI: {
        const hhiRange = criteria[criteriaType]
        if (!hhiRange) return
        return formatUSHHINumberRange(hhiRange)
      }
      case AudienceCriteriaType.ADDITIONAL:
        return criteria[criteriaType]
      default: {
        const values = criteria[criteriaType]
        if (!values) return
        return values.join(', ')
      }
    }
  }

  sentenceCase (title: string) {
    const words = title.split(' ')
    if (words.length > 1) {
      const sentenceCase = words.map((word, index) => {
        if (index) {
          return word.toLowerCase()
        } else {
          return word
        }
      })
      return sentenceCase.join(' ')
    } else {
      return words.join(' ')
    }
  }
}
